import React from 'react'
import moment from 'moment'

export function money(value) {
    return "$" + Number(value || 0).toLocaleString("en-AU")
}

export function moneyCents(value) {
    return "$" + Number(value || 0).toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

export function drawDate(value) {
    if (!value) return ""
    return moment(value).format("D MMMM YYYY, h:mm A")
}

export function clientUrl(client) {
    return client && client.stub ? client.stub : ""
}

export function publicUrl(client) {
    return "https://s50.events/" + clientUrl(client)
}

export function brandStyles(client, event) {
    const styles = (client && client.styles) || {}
    const logoScale = Math.min(1.8, Math.max(0.6, Number(styles.logoScale || 1)))
    return {
        backgroundUrl: (event && event.heroImageUrl) || styles.backgroundUrl || styles.hero || "",
        overlayColor: (event && event.overlayColor) || styles.overlayColor || "#020817",
        overlayOpacity: Number((event && event.overlayOpacity) || styles.overlayOpacity || 58) / 100,
        primaryColor: styles.secondaryColor || "#f97316",
        secondaryColor: styles.primaryColor || "#0ea5e9",
        logoUrl: styles.logo || "",
        logoScale: Number.isFinite(logoScale) ? logoScale : 1,
        logoMask: styles.logoMask || styles.logoFrame || "rounded",
        logoBackgroundColor: styles.logoBackgroundColor || styles.logoBg || "#ffffff",
        prizePoolMessageOverrideEnabled: Boolean(styles.prizePoolMessageOverrideEnabled),
        prizePoolMessageOverride: styles.prizePoolMessageOverride || ""
    }
}

export function prizePoolMessage(client, event) {
    const brand = brandStyles(client, event)
    const cause = (event && event.cause) || (client && client.name) || "your organisation"
    return brand.prizePoolMessageOverrideEnabled && brand.prizePoolMessageOverride
        ? brand.prizePoolMessageOverride
        : "Buy a ticket to support " + cause + " and for your chance to win 50% of the final prize pool."
}

export function logoFrameClass(mask) {
    if (mask === "circle") return "v2-logoFrame v2-logoFrame--circle"
    if (mask === "shield") return "v2-logoFrame v2-logoFrame--shield"
    if (mask === "none") return "v2-logoFrame v2-logoFrame--none"
    return "v2-logoFrame v2-logoFrame--rounded"
}

export function logoNode(client, event, className) {
    const brand = brandStyles(client, event)
    const organisation = (client && client.name) || "S50"
    const letter = organisation.trim().charAt(0).toUpperCase() || "S"
    const style = brand.logoMask === "none" ? null : { backgroundColor: brand.logoBackgroundColor }
    const imageStyle = { transform: "scale(" + brand.logoScale + ")", transformOrigin: "center center" }
    return (
        <div className={(className || "") + " " + logoFrameClass(brand.logoMask)} style={style}>
            {brand.logoUrl ? <img src={brand.logoUrl} alt={organisation} style={imageStyle} /> : <span>{letter}</span>}
        </div>
    )
}

export function ticketBundles(event) {
    return (event && event.ticketBundles && event.ticketBundles.length ? event.ticketBundles : [
        { tickets: 1, price: 25 },
        { tickets: 3, price: 50 },
        { tickets: 8, price: 100 }
    ]).map((bundle) => ({
        tickets: Number(bundle.tickets),
        price: Number(bundle.price)
    }))
}

export function defaultBundleIndex(bundles) {
    if (!bundles || !bundles.length) return 0
    return Math.max(0, Math.ceil(bundles.length / 2) - 1)
}
